export const productInfo = {
    invoiceNumber : 2341312,
    discount : 30,
    info : [
        {
            description : 'Logo Design',
            price : 440,
            qty : 2,
        },
        {
            description : 'Web Site Design',
            price : 120,
            qty : 4,
        },
        {
            description : 'Logo Design',
            price : 300,
            qty : 1,
        },
    ] 
}
export const location = [
    '#Main Road',
    '#Building Name',
    '#Country',
]
export const companyConnections = {
    connection : {
        address : 'your street addres here',
        number : '000 000 000',
        email : 'www.ClothingCo.com',
    }
}
export const customerInfo = {
    info :{
        name : '#Customer Name',
        address : 'your street addres here',
        number : '000 000 000',
        email : 'www.kahlousObada@gmail.com',
    }
}
export const companyInfo = {
    info :{
        managerName : '#Manager Name',
        customerName : '#Customer Name',
        productName : '#Product Name',
    }
}
export const paymentInfo=[
    {
        label : 'Account',
        value : '#000 0000 000',
    },
    {
        label : 'A/C NAME',
        value : '#000 0000 000',
    },
    {
        label : 'BANK DETAILS',
        value : '#Your Account',
    }, 
]